export type Account = {
    name: string;
    email: string;
    phone: string;
    username: string;
    login_name: string;
};

// 展示账户姓名
export const normalizeAccountName = (account: Account) => {
    return account.name;
};

// 展示邮箱>手机号>用户名
export const normalizeAccountEPU = (account: Account) => {
    return account.email || account.phone || account.username || account.login_name;
};
